type ClerkEmailAddress = {
  emailAddress?: string | null;
};

type ClerkIdentityUser = {
  id?: string | null;
  fullName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  primaryEmailAddress?: ClerkEmailAddress | null;
  emailAddresses?: ClerkEmailAddress[] | null;
};

export type AnalyticsUserIdentity = {
  identityKey: string;
  properties?: Record<string, string>;
  userId: string;
};

function normalizeValue(value: string | null | undefined) {
  const trimmed = value?.trim();
  return trimmed ? trimmed : undefined;
}

function resolveEmail(user: ClerkIdentityUser) {
  const primaryEmail = normalizeValue(user.primaryEmailAddress?.emailAddress);
  if (primaryEmail) {
    return primaryEmail;
  }

  for (const emailAddress of user.emailAddresses ?? []) {
    const candidate = normalizeValue(emailAddress.emailAddress);
    if (candidate) {
      return candidate;
    }
  }

  return undefined;
}

export function getAnalyticsUserIdentity(user: ClerkIdentityUser | null | undefined): AnalyticsUserIdentity | null {
  const userId = normalizeValue(user?.id);
  if (!userId) {
    return null;
  }

  const firstName = normalizeValue(user?.firstName);
  const lastName = normalizeValue(user?.lastName);
  const name = normalizeValue(user?.fullName) ?? normalizeValue([firstName, lastName].filter(Boolean).join(" "));
  const email = user ? resolveEmail(user) : undefined;

  const properties: Record<string, string> = {};
  if (email) {
    properties.email = email;
  }
  if (name) {
    properties.name = name;
  }
  if (firstName) {
    properties.first_name = firstName;
  }
  if (lastName) {
    properties.last_name = lastName;
  }

  return {
    identityKey: JSON.stringify({
      email,
      firstName,
      lastName,
      name,
      userId,
    }),
    properties: Object.keys(properties).length > 0 ? properties : undefined,
    userId,
  };
}
